export default "__VITE_ASSET__BbRVXGpG__"